import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { LogoComponent } from '@components/shared/logo/logo.component';
import { TranslationService } from '@services/translation.service';

@Component({
  selector: 'app-menu-card',
  standalone: true,
  imports: [
    LogoComponent
  ],
  templateUrl: './menu-card.component.html',
  styleUrl: './menu-card.component.css'
})
export class MenuCardComponent {

  @Input()
  public title!:       string;

  @Input()
  public image!:       string | undefined;

  @Input()
  public active:       boolean = false;

  @Input()
  public reverse:      boolean = false;

  @Output()
  public itemClicked:  EventEmitter<void> = new EventEmitter<void>();

  public readonly translation: TranslationService = inject(TranslationService);
  

  public onClick(): void {
    this.itemClicked.emit();
  }

}
